// CompletedTaskDetails.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const CompletedTaskDetails = () => {
  const [tasks, setTasks] = useState([]);
  const [employeeMap, setEmployeeMap] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const status = "completed"; // filtering tasks with status "Completed"
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem("token") || "YOUR_FALLBACK_TOKEN";
        const config = { headers: { Authorization: `Bearer ${token}` } };

        // 1. Fetch employee list and create mapping from employee_id to employee_name
        const empResponse = await axios.get("https://attendanceapi.gensparc.com/employee/list", config);
        const employeeList = empResponse.data;
        const map = {};
        employeeList.forEach((emp) => {
          map[emp.employee_id] = emp.employee_name;
        });
        setEmployeeMap(map);

        // 2. Fetch task list
        let response = await axios.get("https://attendanceapi.gensparc.com/task/list", config);
        let tasksData = response.data;
        if (!Array.isArray(tasksData) && tasksData.data) {
          tasksData = tasksData.data;
        }
        // Filter tasks whose status matches "completed" (case-insensitive)
        const filteredTasks = tasksData.filter(
          (task) =>
            task.status &&
            task.status.trim().toLowerCase() === status
        );
        setTasks(filteredTasks);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);
  const handleBackClick = () => {
    navigate("/dashboard") ;
  };

  return (
    <Box sx={{ padding: 0, backgroundColor: "#fafafa", minHeight: "100vh" }}>
     <Box display="flex" alignItems="center" marginBottom={3}>
        <IconButton
          onClick={handleBackClick}
          aria-label="back"
          sx={{ marginTop: 8 }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ flexGrow: 1, textAlign: "center", marginTop: 10 }}
        >
          Completed Task Details 
        </Typography>
      </Box>
      {isLoading ? (
        <Typography variant="body1" align="center">
          Loading tasks...
        </Typography>
      ) : tasks.length > 0 ? (
        <TableContainer component={Paper} sx={{ maxWidth: "auto", margin: "auto" }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#f4f5f7" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Task ID</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Task Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Task Type</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Employee</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Start Date</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>End Date</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.map((task) => (
                <TableRow key={task.task_id}>
                  <TableCell>{task.task_id}</TableCell>
                  <TableCell>{task.task_name}</TableCell>
                  <TableCell>{task.task_type}</TableCell>
                  {/* Look up employee_name using employeeMap */}
                  <TableCell>
                    {employeeMap[task.employee_id] || task.employee_id}
                  </TableCell>
                  <TableCell>
                    {moment(task.start_date).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell>
                    {moment(task.end_date).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell>{task.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1" align="center">
          No tasks found for Completed.
        </Typography>
      )}
    </Box>
  );
};

export default CompletedTaskDetails;
